import apiFetch from '../apiFetch'

export default function (token, id) {
  return apiFetch({ endPoint: `FinancingTypeProduct/CheckAndGetProductTypeUses/${id}`, method: 'GET', body: null, token: token })
}
